(function() {
    'use strict';
    
a3_cabin_reports.controller('DebugCtrl',DebugCtrl);
    
    /**
    * @memberof CabinReports
    * @ngdoc controller
    * @name DebugCtrl
    * @description 
    *  Manage Debug view
    * @ngInject
    */  
function DebugCtrl($location, $scope, UserFactory, DebugFactory, localStorageMD5Service) {

		$scope.isSecure = UserFactory.isSecure();
		$scope.adminkey = "";
		$scope.authorized = false;


		// show logged user info
		var user = UserFactory.getUser();
		$scope.logged_user_info = "-user has not logged in-";
		if (user)
			$scope.logged_user_info = user.aimsId + ' - ' + user.name;

		$scope.storedValues = [];
		$scope.addKeyName = null;
		
        $scope.checkAuthorized = checkAuthorized;
        $scope.refreshStoredValues = refreshStoredValues;


		$scope.add = add;

		$scope.update = update; 

		$scope.delete = deleteFromStorage;
    
		$scope.exit = exit;
        
        $scope.updateAll = updateAll;
            
                
         /**
        * Update all the local storage 
        * @memberof DebugCtrl
        */
        function updateAll()
        {
            try {
                var  items =  JSON.parse($scope.updateAllJson); 
                            
                for(var i=0; i<items.length;i++){
                    var obj = null;
                    if (items[i].value != '') obj = angular.fromJson(items[i].value);
                    localStorageMD5Service.set(items[i].key, obj);
                }

                $scope.refreshStoredValues();
                
			} catch (e) {
				alert('Error: ' + e.message || e.errorMessage);
			}


        }
        
         /**
        * Add a new local storage key
        * @memberof DebugCtrl
        */
        function add() {
			try {
				var key = $scope.addKeyName;
				if (!key || key == '') return false;
				var keys = localStorageMD5Service.keys();
				if (keys && keys.indexOf(key) > 0) {
					alert('Key exists!');
					return false;
				}
				localStorageMD5Service.set(key, ["empty"])
				$scope.refreshStoredValues();
				$scope.addKeyName = null;
			} catch (e) {
				alert('Error: ' + e.message || e.errorMessage);
			}
		}
    
        /**
        * Update an existing local storage key
        * @memberof DebugCtrl
        * @param {object} item
        */
        function update(item) {
			try {
				var obj = null;
				if (item.value != '') obj = angular.fromJson(item.value);
				localStorageMD5Service.set(item.key, obj);
				$scope.refreshStoredValues();
			} catch (e) {
				alert('Error: ' + e.message || e.errorMessage);
			}
		}
    
        /**
        * delete an existing local storage key
        * @memberof DebugCtrl
        * @param {object} item
        */
        function deleteFromStorage(item) {
			if (confirm('Confirm deletion of key ' + item.key)) {
				localStorageMD5Service.remove(item.key);
				$scope.refreshStoredValues();
			}
		}
    
        /**
        * Check if the user is authorized in order to view key values
        * @memberof DebugCtrl
        */
        function checkAuthorized() {
			var verify = localStorageMD5Service.md5hash($scope.adminkey);
			DebugFactory.CheckAuthorized(verify, function(responseData){
				if ($scope.authorized != responseData.data.data) {
					$scope.authorized = responseData.data.data;
					$scope.refreshStoredValues();
				}
			}).catch(function(error){
				$scope.authorized = responseData.Data;
				console.error('Wrong Password', error.status, error.statusText);
			});
		}
            
        /**
        * Refresh values from localstorage
        * @memberof DebugCtrl
        */
        function refreshStoredValues() {
			var values = [];
			if ($scope.authorized) {
				var keys = localStorageMD5Service.keys();
				if (keys) {
					var key, value, sizeActual, error;
					for (var i = 0; i < keys.length; i++) {
						key = keys[i];
						try {
							value = localStorageMD5Service.get(key);
							value = angular.toJson(value);
							sizeActual = localStorageMD5Service.usedSize(key);
							error = null;
						} catch (e) {
							error = e.message || e.errorMessage;
						}
						values.push({
							key: key,
							value: value,
							error: error,
							size: (value) ? value.length : 0,
							sizeActual: sizeActual
						});
					}
				}
			}
			$scope.storedValues = values;

		}
    
        /**
        * Redirect to main Menu
        * @memberof DebugCtrl
        */
        function exit() {
			$location.path("/");
		}


	}

})();